import { render, staticRenderFns } from "./MasterMenu.vue?vue&type=template&id=b14867b6&"
import script from "./MasterMenu.vue?vue&type=script&lang=js&"
export * from "./MasterMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports